import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { fetchAgencyNameSuggestions } from 'components/CommonUtilityServices/EventHandlerService';
import { Autocomplete, Box, TextField } from 'components/AORedesign';
import { useDebounce } from 'hooks/useDebounce';
import { getAgencyCodeFromSuggestion } from './DbcReport.api';

const MIN_SEARCH_LENGTH = 3;

const DbcInternalAgencyPicker = ({ agencyCode, onAgencyCodeChange }) => {
  const [agencyName, setAgencyName] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [debouncedSearchText, setDebouncedSearchText] = useDebounce('');

  useEffect(() => {
    if (debouncedSearchText.length < MIN_SEARCH_LENGTH) {
      setSuggestions([]);
      return undefined;
    }
    // Ignore responses for searches the user has already typed past.
    let isCurrent = true;
    fetchAgencyNameSuggestions(debouncedSearchText)
      .then((result) => isCurrent && setSuggestions(result))
      .catch((error) => console.error(error));
    return () => {
      isCurrent = false;
    };
  }, [debouncedSearchText]);

  const handleSearchTextChange = (e, value, reason) => {
    setSearchText(value);
    setDebouncedSearchText(value);
    // Editing the name invalidates the code taken from a previous selection.
    if (reason === 'input') onAgencyCodeChange('');
  };

  const handleAgencyNameChange = (e, value) => {
    setAgencyName(value);
    onAgencyCodeChange(value ? getAgencyCodeFromSuggestion(value) : '');
  };

  const handleAgencyCodeChange = (e) => {
    setAgencyName(null);
    setSearchText('');
    setSuggestions([]);
    onAgencyCodeChange(e.target.value);
  };

  return (
    <>
      <Box mb={2}>
        <Autocomplete
          id="dbc-agency-name"
          style={{ width: 400 }}
          options={suggestions}
          value={agencyName}
          inputValue={searchText}
          onChange={handleAgencyNameChange}
          onInputChange={handleSearchTextChange}
          renderInput={(params) => <TextField {...params} label="Agency Name" placeholder="Enter Search Input" variant="outlined" />}
        />
      </Box>
      <Box mb={2}>
        <TextField id="dbc-agency-code" label="Agency Code" placeholder="Enter Search Input" value={agencyCode} onChange={handleAgencyCodeChange} />
      </Box>
    </>
  );
};

DbcInternalAgencyPicker.propTypes = {
  agencyCode: PropTypes.string.isRequired,
  onAgencyCodeChange: PropTypes.func.isRequired,
};

export default DbcInternalAgencyPicker;
